<his-plam [hisDdKey]="dDKey">
	<div class="selectContainer">
		<p-autoComplete #content
			[(ngModel)]="selectedConference"
			[suggestions]="filteredConferences"
			field="defaulttext"
			[size]="30"
			[minLength]="1"
			[forceSelection]="true"
			(completeMethod)="filterConference($event)"
			(onSelect)="onSelectByAutocomplete()"
			(onClear)="onClear()"
			[hisDdKey]="dDKey">
		</p-autoComplete>
	</div>

	<div class="selectContainer">
		<his-search-select-popup
			[searchConfigFile]="moduleOptions.SEARCH_CONFIGURATION_FILENAME"
			[selectedOptions]="getConferences()"
			selectedOptionsIdColumn="Conference.id"
			[showDeleteButton]="false"
			[singleSelect]="true"
			(selectedOptionsChange)="onSelectBySearchPopup($event)">		
			<div class="infoMessage">
				{{'fs.res.publication.conference.search.notFoundQuestion' | hisUi}}		
            </div>
            <a *ngIf="auth.hasAnyArray(moduleOptions.RIGHT_CREATE_FROM_MENU)" (click)="onBeforeNavigate()" [routerLink]="['/pub/conference/create/']" [queryParams]="{fromForm: true}" hisImage="context_add" class="transparent">
                <span>{{'fs.res.publication.conference.search.create' | hisUi}}</span>
            </a>			
		</his-search-select-popup>

		<!-- Konferenz bearbeiten -->
	    <a *ngIf="selectedConference && auth.hasAnyArray(moduleOptions.RIGHT_EDIT)" class="transparent"
			[routerLink]="['/pub/conference/edit/', selectedConference.id]" [queryParams]="{fromForm: true}"
			(click)="onBeforeNavigate()" hisImage="PENCIL">{{'fs.res.publication.conference.edit' | hisUi}}</a>

		<!-- Neue Konferenz anlegen -->
		<a *ngIf="auth.hasAnyArray(moduleOptions.RIGHT_CREATE)" (click)="onBeforeNavigate()" [routerLink]="['/pub/conference/create/']" [queryParams]="{fromForm: true}" hisImage="context_add" class="transparent">
			<span>{{'fs.res.publication.conference.search.create' | hisUi}}</span>
		</a>
	</div>
</his-plam>
